import styled from 'styled-components';
import Card from '@klv/molecules/card';
import Grid from '@klv/utils/grid';
import type { TColorVariant } from '@klv/shared/styles/types';
import Typography from '@klv/atoms/typography';

export const StyledCards = styled.div<{ $variant: TColorVariant; }>`
  overflow: hidden;
  ${({ theme, $variant }) => `
    background-color: ${theme.cards[$variant].background};
    color: ${theme.cards[$variant].text};
  `}
`;

export const StyledGrid = styled(Grid)`
  grid-template-rows: repeat(2, auto);
  grid-template-areas:
    "header header header header header header header header"
    "cards cards cards cards cards cards cards cards";
  row-gap: 5.6rem;
  
  ${({ theme }) => `
    ${theme.globalPadding};
    ${theme.screenSize.s576.mediaQuery} {
      grid-template-areas:
        "header header header header header header header header header header header header"
        "cards cards cards cards cards cards cards cards cards cards cards cards";
    }
    ${theme.screenSize.s768.mediaQuery} {
      grid-template-areas:
        "header header header header header header header header header header header header"
        "spacer spacer cards cards cards cards cards cards cards cards cards cards";
    }
    ${theme.screenSize.s1024.mediaQuery} {
      grid-template-areas:
        "header header header header header header header header header header header header"
        "spacer spacer spacer spacer cards cards cards cards cards cards cards cards";
    }
    ${theme.screenSize.s1200.mediaQuery} {
      grid-template-rows: unset;
      grid-template-areas: "header header header header header spacer cards cards cards cards cards cards";
    }
  `}
`;

export const HeadlineGroup = styled.div`
  grid-area: header;
`;

export const StyledSubhead = styled(Typography)`
`;

export const StyledHeadline = styled(Typography)`
  margin-bottom: 1rem;
  ${({ theme }) => `
    ${theme.screenSize.s380.mediaQuery} {
      margin-bottom: 1.9rem;
    }
  `}
`;

export const CardGroup = styled.div`
  grid-area: cards;
  display: grid;
  row-gap: 5.6rem;
  grid-template-columns: repeat(8, 1fr);
  ${({ theme }) => `
    column-gap: ${theme.screenSize.s380.gridColumnGap}rem;
    ${theme.screenSize.s576.mediaQuery} {
      grid-template-columns: repeat(12, 1fr);
    }
    ${theme.screenSize.s768.mediaQuery} {
      grid-template-columns: repeat(10, 1fr);
    }
    ${theme.screenSize.s1024.mediaQuery} {
      grid-template-columns: repeat(8, 1fr);
    }
    ${theme.screenSize.s1366.mediaQuery} {
      grid-template-columns: repeat(6, 1fr);
    }
  `}
`;

export const StyledCard = styled(Card)`
  grid-column: span 8;
  ${({ theme }) => `
    column-gap: ${theme.screenSize.s380.gridColumnGap}rem;
    ${theme.screenSize.s576.mediaQuery} {
      grid-column: span 6;
    }
    ${theme.screenSize.s768.mediaQuery} {
      grid-column: span 5;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      grid-column: span 4;
    }
    ${theme.screenSize.s1366.mediaQuery} {
      grid-column: span 3;
    }
  `}
`;
